import React from "react";
import { formatLogoDate } from "../../helper/utils";
import "./logo-date.m.css";

const LogoDate = () => {
  const date = formatLogoDate(new Date());
  return <div styleName="date">{date}</div>;
};

export default LogoDate;
